import { GlassPanel } from '../ui/GlassPanel';
import { EasterEggMessage } from '../ui/EasterEggMessage';

const ROLES = ['IT Manager', 'Developer', 'Consultant'];

export function IdentityCard({ easterEggPhase, onEasterEggMessageDone }) {
  return (
    <GlassPanel
      as="article"
      aria-label="Identity"
      className="flex flex-col justify-between p-6 lg:p-8 h-full overflow-hidden"
    >
      <div className="flex flex-col gap-4">
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[var(--color-text)] leading-none tracking-tight">
          Simone
          <br />
          <em className="not-italic text-[var(--color-accent)]">Carani</em>
        </h1>

        <ul
          aria-label="Professional roles"
          className="flex flex-wrap gap-2 mt-1"
        >
          {ROLES.map((role) => (
            <li
              key={role}
              className="text-xs font-medium tracking-widest uppercase text-[var(--color-muted)]"
            >
              {role}
              {role !== ROLES[ROLES.length - 1] && (
                <span aria-hidden="true" className="ml-2 text-[var(--color-accent)]/40">
                  /
                </span>
              )}
            </li>
          ))}
        </ul>

        {easterEggPhase === 'captured' && (
          <EasterEggMessage onDone={onEasterEggMessageDone} />
        )}
      </div>

      <div className="mt-auto pt-6">
        <p className="text-[var(--color-muted)] text-sm leading-relaxed max-w-xs">
          Developer and consultant, with an open, ecological and DYT approach.
        </p>
        <p className="text-[var(--color-text)]/60 text-sm leading-relaxed mt-2 max-w-xs italic font-serif">
          "I provide the tools to ask what you want to your data."
        </p>
      </div>
    </GlassPanel>
  );
}
